var _metadata, _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeekingDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: 124,
    height: 57,
    viewBox: "0 0 124 57",
    fill: "none",
    id: "svg842",
    sodipodiDocname: "dog.svg",
    inkscapeVersion: "1.0.1 (3bc2e813f5, 2020-09-07)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata848"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcRype", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs846"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1017,
    id: "namedview844",
    showgrid: "false",
    inkscapeZoom: 65.937498,
    inkscapeCx: 123.93229,
    inkscapeCy: 54.636899,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg842",
    "inkscapeDocument-rotation": 0,
    "inkscapeSnap-grids": "true",
    "inkscapeSnap-page": "false"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect430",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.38961
    },
    d: "m 12,51 v 6 h 13.517241 v -6 z m 22.206896,0 v 6 H 68 v -6 z m 55.034483,0 v 6 H 124 v -6 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect436",
    style: {
      fill: "#000000"
    },
    d: "m 45,3 v 3 h -4 -3 v 3 h -3 v 4 h -6 v 3 h -4 -6 -6 v -3 h -3 v 3 3 H 9 6 v 3 h 3 1 v 3 h 3 3 v 3 h 3 3 v -3 h 3 3 1 v 3 4 h -1 -3 v 3 3 h -3 v 3 h 3 3 4 3 3 v 3 3 h 3 3 v -3 -3 h 4 v -3 h 3 v -3 -3 h 3 3 v 3 h 3 4 v 3 3 h 3 v 3 h 3 3 v -3 h 1 2 4 3 3 v -3 h 3 v -3 -3 -4 h -3 v -3 -3 h 3 v -3 h 1 2 V 16 H 90 89 V 13 H 86 83 80 79 V 10 H 76 73 70 V 9 6 H 67 64 60 V 3 h -3 -3 -3 -3 z m 63,19 v 3 h -3 v 3 4 3 3 3 3 3 h 3 v 4 h 3 v -4 h 4 v -3 h -3 v -3 h 3 3 v -3 h -3 v -3 h 3 v -3 -3 h -3 v 3 h -4 v -4 -3 -3 z m 10,32 v 3 h 3 v -3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect444",
    style: {
      fill: "#c4c4c4"
    },
    d: "M 3,0 V 3 H 0 v 3 3 h 3 v 4 3 h 3 v 3 h 4 v -3 -3 h 3 V 9 6 H 10 9 V 3 H 6 V 0 Z m 10,13 v 3 h 3 v -3 z m 79,3 v 3 h -3 v 3 h -3 v 3 3 h 3 v 4 3 3 h -3 v 3 3 h 3 v 3 h 3 v 4 h 4 v 3 h 3 v 3 h 3 3 v -3 h -3 v -3 h -3 v -4 h 3 v -3 h 3 v -3 -3 -3 -3 -4 -3 h -3 v -3 h -3 v -3 h -4 v -3 z m 23,19 v 3 h 3 v -3 z m -55,3 v 3 3 h -3 v 3 4 3 h 3 v -3 h 3 v -4 h 1 3 v -3 -3 h -3 v -3 z m 0,16 v 3 h 3 V 54 Z M 22,41 v 3 3 1 h -3 v 3 3 h 3 3 v -3 -4 h 3 v -3 -3 h -3 z m -3,13 h -3 v 3 h 3 z m 96,-13 v 3 3 h -4 v 4 3 3 h 4 3 v -3 -3 -4 -3 -3 z m -77,6 v 4 3 h 3 v 3 h 4 3 v -3 h -3 -1 v -3 -4 h -3 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeekingDog);
export default __webpack_public_path__ + "static/media/seeking-dog.1faf3ccd9e4c2608cd7215409f6155c5.svg";
export { ForwardRef as ReactComponent };